export function getGroupFolderKey(deviationId, _a) {
    var groupId = _a.groupId, type = _a.type, folderId = _a.folderId;
    return "".concat(deviationId, ":").concat(groupId, ":").concat(type, ":").concat(folderId);
}
export function getGroupsStreamId() {
    return 'groups';
}
export function getFolderStreamId(type, groupId) {
    return "folders:".concat(groupId, ":").concat(type);
}
//# sourceMappingURL=helpers.js.map